export const DOCUMENTS_GRID_CLASS = 'user-login-activity-documents-grid'

export const documentsGridStyle = {
  '--tc-table-header-bg-color': 'transparent',
  '--tc-table-header-color': '#9AA1AA',
  '--tc-table-header-divider-color': '#E1E3E6',
  '--tc-table-divider-color': '#E8EAED',
  '--tc-table-radius': '0',
  '--tc-table-hover-bg-color': 'transparent',
  '--tc-table-hover-color': 'inherit'
}

export const documentsHeaderStyle = {
  color: '#9AA1AA',
  fontSize: '0.875rem',
  fontWeight: 600,
  borderTop: '1px solid #E1E3E6',
  borderBottom: '1px solid #E1E3E6',
  padding: '.5rem 0.75rem',
  backgroundColor: 'transparent'
}

export const documentsCellStyle = {
  padding: '0.875rem 1rem',
  backgroundColor: '#fff'
}
